<template>
  <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.71054 6.71L6.30054 9.3C6.69054 9.69 7.32054 9.69 7.71054 9.3L10.3005 6.71C10.9305 6.08 10.4805 5 9.59054 5H4.41054C3.52054 5 3.08054 6.08 3.71054 6.71Z"
      fill="currentColor"
    />
  </svg>
</template>
